import { Colors } from "@jsq/ds/styles";
import { ConfirmDialog } from "./ConfirmDialog";

type QueryCannotBeArchivedModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const QueryCannotBeArchivedModal = ({
  isOpen,
  onClose,
}: QueryCannotBeArchivedModalProps) => (
  <ConfirmDialog
    isOpen={isOpen}
    onClose={onClose}
    title="Query cannot be archived"
    heading="Query cannot be archived"
    description="You cannot archive this query while it is in use by active templates. Archive the associated templates before trying again."
    icon={{ type: "exclamation-circle", color: Colors.Danger600 }}
    action={{ kind: "single", label: "Okay, got it", testId: "query-cannot-archive-ok-btn" }}
    testId="query-cannot-be-archived-modal"
  />
);
